import { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { context as KpiContext } from '../../../context/kpi.context';

function NewDashboardMainLayoutComponent(props) {
  const { chartWindows, process } = props;
  const [shouldExpand, setShouldExpand] = useState(false);
  var fetchKpiLinks = useContext(KpiContext).fetchKpiLinks;
  const set_user_accessibility = useSelector(
    (state) => state.userAccessibility.set_user_accessibility
  );

  // Determine column classes based on number of charts
  const getColumnClasses = () => {
    if (shouldExpand) {
      return 'col-md-12 col-lg-12 h-100 chart-layout-expanded';
    }
    
    const chartCount = chartWindows.length;
    if (chartCount === 1) return 'col-md-12 col-lg-12';
    if (chartCount === 2) return 'col-md-12 col-lg-6';
    if (chartCount === 3) return 'col-md-12 col-lg-4';
    if (chartCount >= 4) return 'col-md-12 col-lg-3';
    
    // Default fallback
    return 'col-md-12 col-lg-6';
  };

  const openKpiSlider = (e) => {
    e.preventDefault();
    if (props.kpiMessage) {
      var kpiShareStateObject = {
        openKpiScreen: true
      };
    }
    fetchKpiLinks(kpiShareStateObject);
  };

  const minimizeWindow = () => {
    chartWindows.forEach((_window) => {
      _window.ref.current.className = getColumnClasses();
    });
    setShouldExpand(false);
  };

  const expandWindow = (id) => {
    chartWindows.forEach((_window) => {
      if (_window.id == id) {
        _window.ref.current.className = 'col-md-12 col-lg-12 h-100 chart-layout-expanded';
      } else {
        _window.ref.current.className = 'd-none';
      }
    });
    setShouldExpand(true);
  };

  useEffect(() => {
    if (!props.routeExpand) {
      minimizeWindow();
    }
  }, [props.routeExpand]);

  if (chartWindows) {
    return (
      <div className="row">
        {chartWindows.length > 0 ? (
          chartWindows.map((_window) => {
            const [ChartComponent, xprops] = _window.component();
            return (
              <div 
                key={_window.id} 
                ref={_window.ref} 
                className={getColumnClasses()}
              >
                <ChartComponent
                  expandWindow={expandWindow}
                  minimizeWindow={minimizeWindow}
                  id={_window.id}
                  kpi_id={_window.kpi_id}
                  shouldExpand={shouldExpand}
                  userAccessibility={set_user_accessibility}
                  {...xprops}
                  process={process}
                />
              </div>
            );
          })
        ) : props.kpiMessage ? (
          <h4 className="text-center pt-3 w-100">
            KPI is not set. Please{' '}
            <a href="#" onClick={(e) => openKpiSlider(e)}>
              Set KPI
            </a>{' '}
            to view graphs.
          </h4>
        ) : (
          ''
        )}
      </div>
    );
  } else {
    return null;
  }
}

export default NewDashboardMainLayoutComponent;